if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          copyButton: this.querySelector('[data-share-copy]'),
          instagramButton: this.querySelector('[data-share-instagram]'),
          nativeButton: this.querySelector('[data-share-native]'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          instagramHint: this.querySelector('[data-share-instagram-hint]'),
          urlInput: this.querySelector('[id^="ShareUrl"]'),
          whatsappLink: this.querySelector('[data-share-destination="whatsapp"]'),
          facebookLink: this.querySelector('[data-share-destination="facebook"]'),
          emailLink: this.querySelector('[data-share-destination="email"]'),
        };

        this.titleToShare = this.dataset.shareTitle || document.title;
        this.urlToShare = this.dataset.shareUrl || this.elements.urlInput?.value || document.location.href;
        this.updateUrl(this.urlToShare);

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.elements.copyButton?.addEventListener('click', () => this.copyToClipboard());
        this.elements.closeButton?.addEventListener('click', () => this.closeMenu(true));
        this.elements.instagramButton?.addEventListener('click', () => this.shareToInstagram());

        if (navigator.share) {
          this.elements.nativeButton.hidden = false;
          this.elements.nativeButton.addEventListener('click', () => this.openNativeShare());
        } else if (this.elements.instagramHint) {
          this.elements.instagramHint.textContent =
            'Instagram does not accept pre-filled website shares here. Copy the link, then paste it into Instagram.';
        }
      }

      toggleDetails() {
        this.setStatus('');
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return;
        event.preventDefault();
        this.closeMenu(true);
      }

      closeMenu(restoreFocus = false) {
        this.close();
        if (restoreFocus) this.elements.shareSummary?.focus();
      }

      setStatus(message) {
        if (this.elements.successMessage) this.elements.successMessage.textContent = message;
      }

      async copyToClipboard(message = window.accessibilityStrings?.shareSuccess || 'Link copied.') {
        try {
          await navigator.clipboard.writeText(this.urlToShare);
        } catch (_error) {
          if (!this.elements.urlInput) return false;
          this.elements.urlInput.removeAttribute('aria-hidden');
          this.elements.urlInput.select();
          const copied = document.execCommand('copy');
          this.elements.urlInput.setAttribute('aria-hidden', 'true');
          if (!copied) return false;
        }

        this.setStatus(message);
        return true;
      }

      async openNativeShare(instagramRequested = false) {
        if (!navigator.share) {
          return this.copyToClipboard(
            instagramRequested ? 'Link copied. Paste it into Instagram.' : 'Link copied.'
          );
        }

        try {
          await navigator.share({
            title: this.titleToShare,
            text: this.titleToShare,
            url: this.urlToShare,
          });
          this.setStatus('Shared.');
          return true;
        } catch (error) {
          if (error?.name !== 'AbortError') this.setStatus('Sharing was not available. Please copy the link instead.');
          return false;
        }
      }

      shareToInstagram() {
        return this.openNativeShare(true);
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;

        const encodedUrl = encodeURIComponent(url);
        const encodedTitle = encodeURIComponent(this.titleToShare);
        const encodedMessage = encodeURIComponent(`${this.titleToShare} - ${url}`);

        if (this.elements.whatsappLink) this.elements.whatsappLink.href = `https://wa.me/?text=${encodedMessage}`;
        if (this.elements.facebookLink) {
          this.elements.facebookLink.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        }
        if (this.elements.emailLink) {
          this.elements.emailLink.href = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
        }
      }
    }
  );
}
